import { Component, Input, ViewEncapsulation } from "@angular/core";
import { ProgressBarModule } from "primeng/progressbar";
import { CommonModule } from "@angular/common";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { ExecPipe } from "shared";

@Component({
  selector: "db-progress-bar",
  templateUrl: "./progress-bar.component.html",
  styleUrls: ["./progress-bar.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [ProgressBarModule, CommonModule, VirtualScrollerModule, ExecPipe],
  standalone: true,
})
export class ProgressBarComponent {
  @Input() value: number | undefined = undefined;
  @Input() showValue: boolean = false;
  @Input() mode: "determinate" | "indeterminate" = "indeterminate";
  @Input() borderStyle: "squared" | "rounded" = "squared";
  @Input() separatorsCount = 0;

  protected readonly Array = Array;

  separatorStyle = (counter: number, index: number): string => {
    const left = Math.min(100, (100 * (index + 1)) / counter); // 0 ≤ separator_position_in_% ≤ 100
    const width = Math.max(1, Math.min(4, 100 / (2 * counter))); // 1 ≤ width ≤ 4
    return [
      // "border-radius: 0",
      "height: 4px",
      "background: white",
      `left: ${left}%`,
      `width: ${width}px`,
    ].join("; ");
  };
}
